module.exports = __webpack_public_path__ + "img/phone-landscape.4b122363.svg";